<div *ngIf="labels"><div *ngFor="let l of labels.Items" [innerHTML]="preview ? l.OriginalText : l.Text"></div></div>
<div *ngIf="label" [innerHTML]="preview ? label.OriginalText : label.Text" class="margin-b_one"></div>
